
import Vue from 'vue'

import { tdApi } from "../services/td/td.api.service";
import { INode } from "@/shared/models/node.model";
import { IContainer } from "@/shared/models/container.model";
import GuidelineBox from '../components/GuidelineBox.vue';
import BreadCrumb from '../components/BreadCrumb.vue';
import IntroductionText from '../components/IntroductionText.vue';
import GuidelineToolbar from './GuidelineToolbar.vue';
import { HtmlHelper } from "@/shared/lib/htmlhelper";
import { MarkHelper } from "@/shared/lib/markhelper";


export default Vue.extend({
  name: 'GuidelineArea',

  components: {
    GuidelineBox,
    BreadCrumb,
    IntroductionText,
    GuidelineToolbar
  },

  props: {
    item: Object as () => INode,
    chapter: Object as () => INode,
    showChapters: Boolean as () => boolean,
    phrase: String as () => string,
  },

  data() {
    return {
      conditions: {} as IContainer,
      ready: false as boolean,
      isChapter: false as boolean,
      isIntro: true as boolean
    }
  },

  watch: {
    async item() {
      this.ready = false;
      this.isChapter = this.item.Type === 0;
      this.isIntro = !this.item || !this.item.Name;
      await this.getConditions()
    },
    showChapters(value: boolean) {
      this.ready = value;
    },
    ready(value: boolean) {
      const audioCue = document.getElementById("audio-cue");
      if (value) {
        if (this.showChapters) {
          audioCue!.innerHTML = `Kapitelmeny och introduktionstext är synlig.`;
        } else {
          audioCue!.innerHTML = `Valt kapitel: ${this.chapter.Name}. Valt avsnitt: ${this.item.Name}.`;
        }
      }
    },
  },

  methods: {
    async getConditions() {
      try {
        this.conditions = await tdApi.getConditions(this.item.Id);
        this.prepareConditions(this.conditions);
      } finally {
        this.ready = true;
      }
    },
    getStartPage(): string {
      const helper = new HtmlHelper();
      return helper.getBaseUrl();
    },

    prepareConditions(conditions: IContainer) {
      const helper = new MarkHelper();
      if (this.phrase) {
        conditions.Name = helper.addMarkInText(conditions.Name, this.phrase);
        if(conditions.Description != null){
          conditions.Description = helper.addMarkInText(conditions.Description, this.phrase);
        } 
        conditions.GuidelineItems.forEach(item => {
          item.Name = helper.addMarkInText(item.Name, this.phrase);   
          if(item.Text != null){
            item.Text = helper.addMarkInText(item.Text, this.phrase);
        }     
        });
        conditions.Children.forEach(child => {
          this.prepareConditions(child);
        });
      }
    }
  },
})
